import { render, staticRenderFns } from "./Daily.vue?vue&type=template&id=2b0fb3a2&scoped=true&"
import script from "./Daily.vue?vue&type=script&lang=js&"
export * from "./Daily.vue?vue&type=script&lang=js&"
import style0 from "./Daily.vue?vue&type=style&index=0&id=2b0fb3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0fb3a2",
  null
  
)

export default component.exports